import {
    FETCH_ZONES,
    FETCH_ZONES_SUCCESS,
    FETCH_ZONES_FAILED
} from "../store/types";

const INITIAL_STATE = {
    zones: null,
    loading: false,
    error: null,
};

export const zonesreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ZONES:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_ZONES_SUCCESS:
            return {
                ...state,
                zones: action.payload,
                loading: false,
            };
        case FETCH_ZONES_FAILED:
            return {
                ...state,
                zones: {},
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
